import React from 'react';
import { Spin, Typography } from 'antd';
import './css/CustomSpinner.css';

const CustomSpinner = ({ text = null }) => {
  const { Text } = Typography;
  return text ? <Text className="custom-spin-text">{text}</Text> : <Spin className="custom-spin" />;
};

export default CustomSpinner;